import { Heading } from '../../../components'
import { InstOwnFiler } from '../constants'
import { getInvestorTitles } from '../utils'

interface Props {
  filer?: InstOwnFiler | null
}

export function ManagerHeading({ filer }: Props) {
  const { title, subtitle } = getInvestorTitles(filer)
  return (
    <div className="flex flex-wrap items-baseline">
      <Heading as="h1" level={2} className="mr-4 text-muted">
        {title}
      </Heading>
      {subtitle && (
        <Heading as="h2" level={4} className="text-sm text-muted">
          {subtitle}
        </Heading>
      )}
    </div>
  )
}
